import { useContext, useEffect, useState } from 'react';
// Material UI
import { Box, Link, IconButton, InputAdornment, Alert, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { GoogleLoginButton } from '../UI/Buttons/GoogleButton';
import { useLocation, useNavigate } from 'react-router';
import axios from '../../axios';
import { SubscriptionContext } from '../../contexts/SubscriptionContext';
import { StreakContext } from '../../contexts/StreakContext';
import {
	FooterText,
	LoginButton,
	AuthContainer,
	LoginTitle,
	OrDivider,
	StyledTextField
} from './Login.styles';
import { Role } from './PriorityRules';

export default function Login({
	onInputChange,
	onRegisterClick,
	onResetPasswordClick,
	onLoginClick,
	error,
	updateError,
	isStatusMessage,
	updateUserStatus
}) {
	const location = useLocation();
	const isTeacherLogin = location.pathname === '/login/profesor';
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const { updateUser } = useContext(SubscriptionContext);
	const { setUserId } = useContext(StreakContext);
	const [googleError, setGoogleError] = useState(null);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	// Handle Google login success
	const handleGoogleLoginSuccess = async (code) => {
		setLoading(true);

		try {
			// Send the auth code to the backend
			const res = await axios.post('/api/login/oauth/google', {
				code: code,
				role: isTeacherLogin ? Role.Teacher : Role.Member
			});

			const loginResponse = res.data.message;
			const localStorageUser = {
				access: loginResponse.Access_Token,
				refresh: loginResponse.Refresh_Token,
				isAuthenticated: true,
				role: loginResponse.User.Role,
				userId: loginResponse.User.ID,
				firstName: loginResponse.User.FirstName,
				isFirstLogin: loginResponse.User.IsFirstLogin
			};

			updateUser(localStorageUser);
			setUserId(loginResponse.User.ID);

			localStorage.setItem('userData', JSON.stringify(localStorageUser));
			localStorage.setItem('user', JSON.stringify(loginResponse.User));

			axios.defaults.headers.common.Authorization = `Bearer ${loginResponse.Access_Token}`;

			setLoading(false);
			navigate('/');
		} catch (err) {
			setGoogleError('Autentificarea a eșuat. Te rugăm să încerci din nou.');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const authCode = queryParams.get('code');

		if (authCode) {
			handleGoogleLoginSuccess(authCode);
		}
	}, [location]); // Runs every time the URL changes

	useEffect(
		() => () => {
			updateUserStatus({ statusMessage: '', error: '' });
			updateError(null);
		},
		[updateUserStatus, updateError]
	);

	return (
		<AuthContainer>
			<LoginTitle variant="h4">
				{isTeacherLogin ? 'Acces profesor' : 'Conectează-te la contul tău!'}
			</LoginTitle>

			{error && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{error}
				</Alert>
			)}
			{googleError && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{googleError}
				</Alert>
			)}
			<GoogleLoginButton loading={loading} isTeacherLogin={isTeacherLogin} />

			<OrDivider>
				<span>Sau cu email</span>
			</OrDivider>

			<StyledTextField
				label="Email-ul tău"
				name="email"
				type="email"
				fullWidth
				variant="outlined"
				data-lpignore="true"
				inputProps={{
					autoComplete: 'email'
				}}
				onChange={onInputChange}
			/>

			<StyledTextField
				label="Parola ta"
				name="password"
				fullWidth
				variant="outlined"
				type={showPassword ? 'text' : 'password'}
				id="password"
				data-lpignore="true"
				InputProps={{
					minLength: '8',
					endAdornment: (
						<InputAdornment position="end">
							<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								edge="end"
							>
								{showPassword ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						</InputAdornment>
					)
				}}
				onKeyPress={(e) => {
					if (e.key === 'Enter') {
						onLoginClick();
					}
				}}
				onChange={onInputChange}
			/>

			<Box display="flex" justifyContent="flex-end" mb={2}>
				<Link
					component="button"
					underline="always"
					color="primary"
					onClick={() => onResetPasswordClick()}
				>
					Ai uitat parola?
				</Link>
			</Box>

			<LoginButton fullWidth variant="contained" disableElevation onClick={() => onLoginClick()}>
				Accesează
			</LoginButton>

			<FooterText>
				Nu ai cont încă?{' '}
				<Link
					component="button"
					color="primary"
					underline="always"
					onClick={() => onRegisterClick()}
				>
					Înregistrează-te
				</Link>
			</FooterText>

			{/* {!isTeacherLogin && (*/}
			{/*	<FooterText>*/}
			{/*		Vrei să predai pe platformă?{' '}*/}
			{/*		<Link*/}
			{/*			component="button"*/}
			{/*			color="primary"*/}
			{/*			underline="always"*/}
			{/*			onClick={() => navigate('/login/profesor')}*/}
			{/*		>*/}
			{/*			Devino profesor*/}
			{/*		</Link>*/}
			{/*	</FooterText>*/}
			{/* )}*/}

			{/* {isTeacherLogin && (*/}
			{/*	<FooterText>*/}
			{/*		Ești student?{' '}*/}
			{/*		<Link*/}
			{/*			component="button"*/}
			{/*			color="primary"*/}
			{/*			underline="always"*/}
			{/*			onClick={() => navigate('/login')}*/}
			{/*		>*/}
			{/*			Înapoi la login pentru studenți*/}
			{/*		</Link>*/}
			{/*	</FooterText>*/}
			{/* )}*/}
		</AuthContainer>
	);
}
